

// import React, { useEffect, useState } from "react";
// import { getAllBankAccounts, uploadSingleFile } from "../../services/apiService";
// import { useNavigate } from "react-router-dom";
// import { Card, Button, Alert, Form } from "react-bootstrap";

// const DepositPage = () => {
//   const [accounts, setAccounts] = useState([]);
//   const [file, setFile] = useState(null);
//   const [preview, setPreview] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [msgType, setMsgType] = useState("success");

//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchAccounts = async () => {
//       console.log("🔄 Fetching bank accounts...");
//       try {
//         const data = await getAllBankAccounts();
//         console.log("✅ API Response:", data);

//         if (data && data.accounts && Array.isArray(data.accounts)) {
//           setAccounts(data.accounts);
//         } else {
//           setAccounts([]);
//         }
//       } catch (error) {
//         console.error("❌ Error fetching accounts:", error);
//         setAccounts([]);
//       }
//     };

//     fetchAccounts();
//   }, []);

//   // File upload handlers
//   const handleFileChange = (e) => {
//     const selected = e.target.files[0];
//     setFile(selected);

//     if (selected) {
//       if (selected.type.startsWith("image/")) {
//         setPreview(URL.createObjectURL(selected));
//       } else {
//         setPreview(null);
//       }
//     }
//   };

//   const handleUpload = async () => {
//     if (!file) {
//       setMsgType("danger");
//       setMsg("Please select a file");
//       return;
//     }

//     try {
//       await uploadSingleFile(file);
//       setMsgType("success");
//       setMsg("Uploaded Successfully ✅");
//       setFile(null);
//       setPreview(null);
//     } catch (error) {
//       setMsgType("danger");
//       setMsg("Upload failed ❌");
//       console.error("Upload Error:", error);
//     }
//   };

//   return (
//     <div
//       style={{
//         background: "linear-gradient(135deg, #e3f2fd, #f1f8e9)",
//         minHeight: "100vh",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center",
//         alignItems: "center",
//         padding: "40px 20px",
//       }}
//     >
//       <div
//         style={{
//           background: "#fff",
//           borderRadius: "20px",
//           boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
//           padding: "50px 40px",
//           maxWidth: "600px",
//           width: "100%",
//           textAlign: "center",
//           transition: "all 0.3s ease-in-out",
//         }}
//       >
//         <h1
//           style={{
//             fontWeight: "900",
//             fontSize: "36px",
//             color: "#1565c0",
//             letterSpacing: "2px",
//             marginBottom: "20px",
//           }}
//         >
//           STOCK MARKET INVESTING BY GROW CAPITAL 💹
//         </h1>

//         <p style={{ color: "#555", fontSize: "18px", marginBottom: "30px" }}>
//           Please use the following bank account details to deposit your funds securely.
//         </p>

//         {/* Bank Accounts */}
//         {accounts.length > 0 ? (
//           accounts.map((acc, index) => (
//             <div
//               key={index}
//               style={{
//                 background: "#e3f2fd",
//                 border: "2px solid #90caf9",
//                 borderRadius: "15px",
//                 padding: "25px",
//                 marginBottom: "25px",
//                 boxShadow: "inset 0 0 10px rgba(0,0,0,0.05)",
//               }}
//             >
//               <p style={{ fontSize: "22px", fontWeight: "700", margin: "0 0 10px 0", color: "#0d47a1" }}>
//                 Account No: <b>{acc.accountNumber}</b>
//               </p>
//               <p style={{ fontSize: "20px", fontWeight: "600", color: "#1565c0" }}>
//                 IFSC Code: <b>{acc.ifscCode}</b>
//               </p>
//             </div>
//           ))
//         ) : (
//           <p style={{ fontSize: "18px", color: "#777" }}>Loading account details...</p>
//         )}

//         {/* Upload Document */}
//         <Card className="shadow-lg p-4 mb-4" style={{ borderRadius: "20px" }}>
//           <h4 className="text-center mb-2 fw-bold">Upload Deposit Slip / Document</h4>
//           <p className="text-center text-muted mb-4" style={{ fontSize: "15px" }}>
//             Upload your deposit slip safely
//           </p>

//           {msg && <Alert className="mb-3" variant={msgType}>{msg}</Alert>}

//           <div
//             style={{
//               border: "2px dashed #b7b7b7",
//               borderRadius: "12px",
//               padding: "25px 15px",
//               textAlign: "center",
//               cursor: "pointer",
//               marginBottom: "15px",
//             }}
//             onClick={() => document.getElementById("fileInput").click()}
//           >
//             {!preview ? (
//               <img
//                 src="https://cdn-icons-png.flaticon.com/512/7153/7153160.png"
//                 alt="upload"
//                 style={{ width: "55px", opacity: "0.85", marginBottom: "10px" }}
//               />
//             ) : (
//               <img
//                 src={preview}
//                 alt="Preview"
//                 style={{
//                   width: "100%",
//                   maxHeight: "200px",
//                   borderRadius: "10px",
//                   objectFit: "cover",
//                   marginBottom: "10px",
//                 }}
//               />
//             )}
//             <p className="mb-1 fw-semibold">{file ? "Change File" : "Click to choose file"}</p>
//             <small className="text-muted">(PDF, JPG, PNG, DOC allowed)</small>
//           </div>

//           <Form.Control
//             id="fileInput"
//             type="file"
//             className="d-none"
//             onChange={handleFileChange}
//           />

//           <Button
//             className="w-100 py-2 mt-2 fw-semibold"
//             variant="primary"
//             onClick={handleUpload}
//             style={{ borderRadius: "10px" }}
//           >
//             Upload Now
//           </Button>
//         </Card>

//         <button
//           onClick={() => navigate("/dashboard")}
//           style={{
//             marginTop: "10px",
//             background: "#1565c0",
//             color: "#fff",
//             border: "none",
//             padding: "12px 30px",
//             borderRadius: "10px",
//             fontSize: "16px",
//             fontWeight: "600",
//             cursor: "pointer",
//             transition: "background 0.3s",
//           }}
//           onMouseOver={(e) => (e.target.style.background = "#0d47a1")}
//           onMouseOut={(e) => (e.target.style.background = "#1565c0")}
//         >
//           ← Back to Dashboard
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DepositPage;

import React, { useEffect, useState } from "react";
import { getAllBankAccounts, uploadSingleFile } from "../../services/apiService";
import { API_ROOT } from "../../services/api";
import { useNavigate } from "react-router-dom";
import { Card, Button, Alert, Form } from "react-bootstrap";

// Helper function to build image URL from backend
const getImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) return imagePath;
  const baseUrl = API_ROOT ? API_ROOT.replace(/\/api\/?$/, "") : "http://localhost:5000";
  return `${baseUrl}${imagePath.startsWith("/") ? "" : "/"}${imagePath}`;
};

const DepositPage = () => {
  const [accounts, setAccounts] = useState([]);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [msg, setMsg] = useState("");
  const [msgType, setMsgType] = useState("success");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAccounts = async () => {
      console.log("🔄 Fetching bank accounts...");
      try {
        const data = await getAllBankAccounts();
        console.log("✅ API Response:", data);

        if (data && data.accounts && Array.isArray(data.accounts)) {
          setAccounts(data.accounts);
        } else if (Array.isArray(data)) {
          setAccounts(data);
        } else {
          setAccounts([]);
        }
      } catch (error) {
        console.error("❌ Error fetching accounts:", error);
        setAccounts([]);
      }
    };

    fetchAccounts();
  }, []);

  // File upload handlers
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected);

    if (selected) {
      if (selected.type.startsWith("image/")) {
        setPreview(URL.createObjectURL(selected));
      } else {
        setPreview(null);
      }
    }
  };

  const handleUpload = async () => {
    if (!file) {
      setMsgType("danger");
      setMsg("Please select a file");
      return;
    }

    try {
      await uploadSingleFile(file);
      setMsgType("success");
      setMsg("Uploaded Successfully ✅");
      setFile(null);
      setPreview(null);
    } catch (error) {
      setMsgType("danger");
      setMsg("Upload failed ❌");
      console.error("Upload Error:", error);
    }
  };

  return (
    <div
      style={{
        background: "linear-gradient(135deg, #e3f2fd, #f1f8e9)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
          padding: "50px 40px",
          maxWidth: "600px",
          width: "100%",
          textAlign: "center",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <h1
          style={{
            fontWeight: "900",
            fontSize: "36px",
            color: "#1565c0",
            letterSpacing: "2px",
            marginBottom: "20px",
          }}
        >
          STOCK MARKET INVESTING BY GROW CAPITAL 💹
        </h1>

        <p style={{ color: "#555", fontSize: "18px", marginBottom: "30px" }}>
          Please scan the QR code or use the following bank details to deposit your funds securely.
        </p>

        {/* Bank Accounts with QR Display */}
        {accounts.length > 0 ? (
          accounts.map((acc, index) => (
            <div
              key={index}
              style={{
                background: "#e3f2fd",
                border: "2px solid #90caf9",
                borderRadius: "15px",
                padding: "25px",
                marginBottom: "25px",
                boxShadow: "inset 0 0 10px rgba(0,0,0,0.05)",
              }}
            >
              {/* QR Image Display */}
              {acc.qrImage && (
                <div style={{ marginBottom: "20px" }}>
                  <img
                    src={getImageUrl(acc.qrImage)}
                    alt="Deposit QR Code"
                    style={{
                      width: "180px",
                      height: "180px",
                      objectFit: "contain",
                      background: "#fff",
                      padding: "8px",
                      borderRadius: "12px",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
                    }}
                  />
                  <p style={{ fontSize: "14px", color: "#1565c0", marginTop: "8px", fontWeight: "600" }}>
                    Scan QR Code to Pay
                  </p>
                </div>
              )}

              <p style={{ fontSize: "22px", fontWeight: "700", margin: "0 0 10px 0", color: "#0d47a1" }}>
                Account No: <b>{acc.accountNumber}</b>
              </p>
              <p style={{ fontSize: "20px", fontWeight: "600", color: "#1565c0", margin: 0 }}>
                IFSC Code: <b>{acc.ifscCode}</b>
              </p>
            </div>
          ))
        ) : (
          <p style={{ fontSize: "18px", color: "#777" }}>Loading account details...</p>
        )}

        {/* Upload Document */}
        <Card className="shadow-lg p-4 mb-4" style={{ borderRadius: "20px" }}>
          <h4 className="text-center mb-2 fw-bold">Upload Deposit Slip / Document</h4>
          <p className="text-center text-muted mb-4" style={{ fontSize: "15px" }}>
            Upload your deposit slip safely
          </p>

          {msg && <Alert className="mb-3" variant={msgType}>{msg}</Alert>}

          <div
            style={{
              border: "2px dashed #b7b7b7",
              borderRadius: "12px",
              padding: "25px 15px",
              textAlign: "center",
              cursor: "pointer",
              marginBottom: "15px",
            }}
            onClick={() => document.getElementById("fileInput").click()}
          >
            {!preview ? (
              <img
                src="https://cdn-icons-png.flaticon.com/512/7153/7153160.png"
                alt="upload"
                style={{ width: "55px", opacity: "0.85", marginBottom: "10px" }}
              />
            ) : (
              <img
                src={preview}
                alt="Preview"
                style={{
                  width: "100%",
                  maxHeight: "200px",
                  borderRadius: "10px",
                  objectFit: "cover",
                  marginBottom: "10px",
                }}
              />
            )}
            <p className="mb-1 fw-semibold">{file ? "Change File" : "Click to choose file"}</p>
            <small className="text-muted">(PDF, JPG, PNG, DOC allowed)</small>
          </div>

          <Form.Control
            id="fileInput"
            type="file"
            className="d-none"
            onChange={handleFileChange}
          />

          <Button
            className="w-100 py-2 mt-2 fw-semibold"
            variant="primary"
            onClick={handleUpload}
            style={{ borderRadius: "10px" }}
          >
            Upload Now
          </Button>
        </Card>

        <button
          onClick={() => navigate("/dashboard")}
          style={{
            marginTop: "10px",
            background: "#1565c0",
            color: "#fff",
            border: "none",
            padding: "12px 30px",
            borderRadius: "10px",
            fontSize: "16px",
            fontWeight: "600",
            cursor: "pointer",
            transition: "background 0.3s",
          }}
          onMouseOver={(e) => (e.target.style.background = "#0d47a1")}
          onMouseOut={(e) => (e.target.style.background = "#1565c0")}
        >
          ← Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default DepositPage;